import { ArrowRight } from "lucide-react";
import "./CTABanner.css";

export default function CTABanner() {
  return (
    <section className="cta-banner">
      <div className="cta-banner__img">
        <img
          src="https://images.unsplash.com/photo-1550948390-6eb7fa773072?q=80&w=1474&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D?w=1600&auto=format&fit=crop"
          alt="bg"
        />
      </div>
      <div className="cta-banner__deco">🌿</div>

      <div className="container cta-banner__inner">
        <div className="cta-banner__text">
          <div className="cta-banner__badge">🌱 Penghijauan Efisien, Biar Anda Fokus Berkarya</div>
          <h2 className="cta-banner__title">
            Menetapkan Standar Baru <br />
            <em>Ruang Hijau Indonesia</em>
          </h2>
          <p className="cta-banner__sub">
            Kami bantu Anda menciptakan lingkungan hijau yang indah, sehat, dan lestari — 
            dari konsultasi awal hingga perawatan jangka panjang.
          </p>
        </div>

        <div className="cta-banner__btns">
          <a href="#kontak" className="btn btn-cream">  
            Request Penawaran <ArrowRight size={15} />
          </a>
          <a href="#portofolio" className="cta-banner__ghost">
            Lihat Hasil Kerja Kami →
          </a>
        </div>
      </div>
    </section>
  );
}
